<template>
    <div>
        <ValidationObserver tag="form" ref="observer" @submit.prevent="onSubmit">
            <FormSanciones :sancion="sancion"/>

            <b-button :disabled="loading" type="submit" class="ml-2">Crear</b-button>
        </ValidationObserver>
    </div>
</template>

<script>
    import FormSanciones from './components/FormSanciones';

    export default {
        props: [
            'base_id',
        ],
        data() {
            return {
                sancion: {
                    fecha: null,
                    motivo: null,
                    descripcion: null,
                    importe: null,
                    sancion: null,
                    sin_jugar_hasta: null,
                    impuesta: null,
                    pagar: null,
                    pagado: null,
                    documentos: null
                },
                loading: false
            }
        },
        methods: {
            async onSubmit() {
                const isValid = await this.$refs.observer.validate();
                if (isValid) {
                    this.crearSancion();
                }

            },
            crearSancion() {
                this.loading = true;

                this.sancion.filters = {};
                this.sancion.base_id = this.base_id;
                this.sancion.lista_id = this.lista_id;
                this.sancion.impuesta = this.sancion.impuesta.id;
                this.sancion.pagar = this.sancion.pagar.id;
                this.sancion.pagado = this.sancion.pagado.id;

                this.$store.dispatch(this.config.getVuexAlias('back.bases.sanciones.crear'), this.sancion).then(() => {
                    this.$toast.success('Sanción creada correctamente.');
                    this.$emit('crearSancion');
                }).catch(e => {
                    this.$toast.error(e.response?.data?.message);
                }).finally(() => {
                    this.loading = false;
                });
            }
        },
        computed: {
            lista_id() {
                return this.$route.params.lista_id;
            }
        },
        components: {
            FormSanciones
        }
    }
</script>